import type { IAirportProducts, IAirportStats, IHotelProduct, IParkingProduct } from '@nuxt-monorepo/ui/types';
import type { IParkingStats } from '@nuxt-monorepo/ui/types/ParkingStats';

export function getProductsFromResponse(psf: any): IAirportProducts {
    const hotels: IHotelProduct[] | null = ensureArrayOfObjects(psf.data?.value?.data?.hotels);
    const hotelsWithParking: IHotelProduct[] | null = ensureArrayOfObjects(psf.data?.value?.data?.hotelsWithParking);
    const parking: IParkingProduct[] | null = ensureArrayOfObjects(
        psf.data?.value?.data?.parking?.parking_lots ?? psf.data?.value?.data?.parking_lots ?? null
    );
    const parkingStats: IParkingStats | null = psf.data?.value?.data?.parkinglots_stats ?? null;
    const airportStats: any = psf.data?.value?.data?.psf?.airport_stats
        ? psf.data?.value?.data?.psf.airport_stats
        : psf.data?.value?.data?.airport_stats;

    return { parking, hotels, hotelsWithParking, parkingStats, airportStats };
}

export function ensureArrayOfObjects(value: any) {
    if (!value) {
        return value;
    }

    if (Array.isArray(value)) {
        return value;
    }
    return Object.values(value);
}
